import { render, staticRenderFns } from "./TrainingFollowUp.vue?vue&type=template&id=89b08f7c&scoped=true"
import script from "./TrainingFollowUp.vue?vue&type=script&lang=js"
export * from "./TrainingFollowUp.vue?vue&type=script&lang=js"
import style0 from "./TrainingFollowUp.vue?vue&type=style&index=0&id=89b08f7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b08f7c",
  null
  
)

export default component.exports